import {DynRemote, DynWallet} from '../dyn-xyz-wc/dyn-remote';

export const shortenWalletAddress = (walletAddress: string, first: number = 6, last: number = 4): string =>
    walletAddress
        ? walletAddress.replace(walletAddress.substring(first, Number(walletAddress.length) - last), '...')
        : '';

export const isDynamicEmbeddedWallet = (wallet: DynWallet | undefined, dynRemote: DynRemote) => {
    const EMBEDDED_WALLET_KEY = 'dynamicwaas';

    return wallet && dynRemote.isEthereumWallet(wallet)
        && wallet.key === EMBEDDED_WALLET_KEY;
};
